import { useEffect } from "react"

import { Correct } from "@intergamma/icons"

import { useTranslation } from "react-i18next"
import { Navigate } from "react-router"
import { toast } from "react-toastify"

export function ChangePasswordSuccess() {
  const { t } = useTranslation(["urls", "change-password"])

  useEffect(() => {
    toast.success(t("change-password:successfulSave"), { icon: Correct })
  }, [t])

  return <Navigate to={t("urls:/profile/personal-information")} />
}
